import React, { Component, useState, useEffect } from "react";
import { connect } from "react-redux";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

//Toasts
import { Toaster } from 'sonner'

import Header from "./components/layout/V4/Header";
import Dashboard from "./pages/dashboard/Dashboard3";
// import Report from "./components/_analytics/Report";

//Settings
//import Account from "./components/_settings/Account/Account";
// import GameSettings from "./components/_settings/Game/GameSettings";

// Sentry.io
import * as Sentry from "@sentry/react";



function App(props) {
  const { auth, profile, account, signup_status } = props;
  if (!auth.uid) return <Redirect to="/login" />;

  const [isLoading, setIsLoading] = useState(true)
  const [subscriptionStatus, setSubscriptionStatus] = useState()

  useEffect(()=> {
    //console.log('ACCOUNT', account)
    setTimeout(() => {
      if (account && account.length > 0 ) {
        
        setIsLoading(false)
      }
      if (account && account.length === 0) {
        window.location.replace('/onboarding')
      }
    }, 1000);
  }, [account])

  if (isLoading)
      return (
        <div role="status" className="flex items-center justify-center w-full h-screen">
    <svg aria-hidden="true" className="w-12 h-12 mb-8 text-gray-200 animate-spin dark:text-gray-300 fill-blue-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/>
        <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/>
    </svg>
    <span class="sr-only">Loading...</span>
</div>
      );

  // if (auth.uid && !account) return <div>test</div>
  if (signup_status === "creating_account") {
      return (
        <div className="content ht-100v pd-0">
          <div
            className="text-center"
            style={{
              left: "50%",
              marginLeft: "-2em",
              position: "absolute",
              top: "40%",
            }}
          >
            <h3>Creating User Account</h3>
            <div
              className="spinner-border"
              style={{ width: "5rem", height: "5rem" }}
            ></div>
          </div>
        </div>
      );
    }



  Sentry.setUser({
        email: auth.email,
        id: auth.uid,
      });

  return (
    <BrowserRouter>
        <div className="content ht-100v pd-0">
        <Toaster closeButton position="top-center" />
          <div className="row" style={{ height: "100%", marginRight: "0px" }}>
            <div
              style={{
                width: "100%",
                maxWidth: "1200px",
                padding: "55px 20px 0px",
                margin: "0 auto",
              }}
            >
              <Header
                profile={profile}
                account={account}
              />

              <Switch>
                <Route
                  exact
                  path="/"
                  component={() => <Dashboard account={account} />}
                />
              </Switch>

              <div style={{ position: "fixed", bottom: "0", right: "20px" }}>
                <p>Version {props.app.app_version}</p>
              </div>
            </div>
          </div>
        </div>
      </BrowserRouter>
  )
}

const mapStateToProps = (state) => {
  const account_id = state.firebase.profile.account_id
    ? state.firebase.profile.account_id
    : null;
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    account: state.firestore.ordered.user_accounts
      ? state.firestore.ordered.user_accounts
      : null,
    uid: state.firebase.auth.uid ? state.firebase.auth.uid : "123",
    account_id: account_id,
    signup_status: state.auth.signup_status,
    app: state.app,
  };
};

export default compose(
  connect(mapStateToProps, null),
  firestoreConnect((props) => [
    {
      collection: "user_accounts",
      doc: props.account_id,
    },
  ])
)(App);
